<div class="col-12">
  <div class="bs-callout bs-callout-info">
    <h5 class="titulo-bloco">Dados de Cliente</h5>
    <hr />
    <div class="col-12 pb-1">
      <label><b>Nome:&nbsp;&nbsp;</b></label><label class="center-block">{{entidade?.nome}}</label>
    </div>
    <div class="col-12 pb-1">
      <label><b>Contribuinte:&nbsp;&nbsp;</b></label><label class="center-block">{{entidade?.contribuinte}}</label>
    </div>
    <div class="col-12 pb-1">
      <label><b>Morada:&nbsp;&nbsp;</b></label><label class="center-block">{{entidade?.morada}}</label>
    </div>
    <div class="col-12 pb-1">
      <label><b>Código Postal:&nbsp;&nbsp;</b></label><label class="center-block">{{entidade?.codigoPostal}}</label>
    </div>
    <div class="col-12 pb-1">
      <label><b>Localidade:&nbsp;&nbsp;</b></label><label class="center-block">{{entidade?.localidade}}</label>
    </div>
    <div class="col-12 pb-1">
      <label><b>Email:&nbsp;&nbsp;</b></label><label class="center-block">{{entidade?.email}}</label>
    </div>
  </div>
</div>
